
export default function Footer() {
  return (
    <footer className="relative bg-slate-950 border-t border-slate-800/50">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Left - Logo & Tagline */}
          <div>
            <div className="flex items-center gap-3 mb-4 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/982a164fa40d3ba73c580c5f5b46fc70.png"
                alt="Palemia AI"
                className="h-9 w-9 object-contain"
              />
              <span className="text-white font-semibold text-lg tracking-tight">Palemia AI</span>
            </div>
            <p className="text-gray-500 text-sm max-w-md leading-relaxed">
              Structured Intelligence for Service Leaders.
            </p>
          </div>

          {/* Right - Navigation */}
          <div className="flex justify-start md:justify-end">
            <div className="flex flex-wrap gap-8">
              <a href="#industries" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap">Industries</a>
              <a href="#framework" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap">Framework</a>
              <a href="#results" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap">Case Studies</a>
              <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap">Contact</a>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-8 border-t border-slate-800/50 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-xs">
            &copy; 2026 Palemia AI. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-gray-600 hover:text-gray-400 transition-colors duration-300 text-xs cursor-pointer whitespace-nowrap"
          >
            Web Design
          </a>
        </div>
      </div>
    </footer>
  );
}
